var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 16.5C3.075 16.5 2.8125 16.3875 2.5875 16.1625C2.3625 15.9375 2.25 15.675 2.25 15.375V3.75C2.25 3.45 2.3625 3.1875 2.5875 2.9625C2.8125 2.7375 3.075 2.625 3.375 2.625H4.59375V2.08125C4.59375 1.91875 4.65 1.78125 4.7625 1.66875C4.875 1.55625 5.01875 1.5 5.19375 1.5C5.36875 1.5 5.51562 1.55625 5.63437 1.66875C5.75312 1.78125 5.8125 1.925 5.8125 2.1V2.625H12.1875V2.08125C12.1875 1.91875 12.2438 1.78125 12.3563 1.66875C12.4688 1.55625 12.6125 1.5 12.7875 1.5C12.9625 1.5 13.1094 1.55625 13.2281 1.66875C13.3469 1.78125 13.4062 1.925 13.4062 2.1V2.625H14.625C14.925 2.625 15.1875 2.7375 15.4125 2.9625C15.6375 3.1875 15.75 3.45 15.75 3.75V15.375C15.75 15.675 15.6375 15.9375 15.4125 16.1625C15.1875 16.3875 14.925 16.5 14.625 16.5H3.375ZM3.375 15.375H14.625V7.3125H3.375V15.375ZM3.375 6.1875H14.625V3.75H3.375V6.1875ZM3.375 6.1875V3.75V6.1875Z",
    fill: "#7A5AF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7b4cc86243546c6bfa572c6cece825fa.svg";
export { ForwardRef as ReactComponent };